<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body fluid="xl">
      <b-row class="text-center">
        <b-col cols="12">
            <h2><b-badge variant="info">Covid 19 Vaccination Record Information</b-badge></h2>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col>
          <b-form-group label="Search" label-for="searchText" label-cols-sm="4" label-cols-lg="3">
            <b-form-input id="searchText" name="searchText"  @blur="searchBlur"  @focus="searchTextFocused"   maxlength="15" aria-describedby="liveFeedbackSearchText"  v-model="form.searchText"  />

            <b-list-group v-if="showListGroup" id="searchTextList">
               <b-list-group-item ref="listIndexes" @keydown="keydownMethod(index)" @keyup="keyupMethod(index)"  @click="searchListClicked(item)" v-for="(item,index) in patients" button  v-bind:key="item.cardNo">{{item.cardNo}} - {{item.name}} - {{item.dob}} - {{item.phone}}</b-list-group-item>
            </b-list-group>

            <b-form-invalid-feedback id="liveFeedbackSearchText">
               This is a required field.
             </b-form-invalid-feedback>
          </b-form-group>
          </b-col>

        </b-row>
          </b-card>




      <b-form @submit.stop.prevent="onSubmit">

       <b-row>
         <b-col>
         <b-form-group label="First Name" label-for="firstName" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="firstName" :state="validateState('firstName')" name="firstName"   aria-describedby="liveFeedbackName"  v-model.lazy.trim="$v.form.firstName.$model" />
           <b-form-invalid-feedback id="liveFeedbackName">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Last Name" label-for="lastName" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="lastName" :state="validateState('lastName')" name="lastName"   aria-describedby="liveFeedbackLastName"  v-model.lazy.trim="$v.form.lastName.$model" />
           <b-form-invalid-feedback id="liveFeedbackLastName">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Mobile Number" label-for="mobile" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="mobile" :state="validateState('mobile')" name="mobile"   aria-describedby="liveFeedbackmobile"  v-model.lazy.trim="$v.form.mobile.$model" />
           <b-form-invalid-feedback id="liveFeedbackmobile">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Address" label-for="address" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="address" :state="validateState('address')" name="address"   aria-describedby="liveFeedbackAddress"  v-model.lazy.trim="$v.form.address.$model" />
           <b-form-invalid-feedback id="liveFeedbackAddress">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="AadharCard No" label-for="aadharcard" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="aadharcard"  name="aadharcard"   v-model.lazy.trim="form.adharCardNumber" />

         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
           <b-form-group label="Vaccination Doses" label-for="treatments" label-cols-sm="4" label-cols-lg="3">
             <b-input-group id="treatments" name="treatments">
               <b-input-group-prepend>
                 <b-button variant="outline-info" @click="removeTreatment">Remove Dose</b-button>
               </b-input-group-prepend>
               <b-form-input v-model="numberOfTreatments" disabled></b-form-input>
               <b-input-group-append>
                 <b-button variant="success" @click="addTreatment">Add Dose</b-button>
               </b-input-group-append>
             </b-input-group>
           </b-form-group>
          <b-form-group label="" label-for="" label-cols-sm="4" label-cols-lg="3">
            <treatment-list @doseAdded="setDoses" ref="treatmentList"></treatment-list>
          </b-form-group>
         </b-col>
       </b-row>
       <b-row align-h="center">
       <b-col  cols="4" >

       <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
         Save
       </b-button>
        <b-button class="ml-1"  @click="onReset">Close</b-button>


       </b-col>


       </b-row>
      </b-form>
      <div id="vCard" style="display:none;">
        <vaccination-print-card  ref="vacPrintCard"></vaccination-print-card>
      </div>
    </b-card-body>

  </b-card>
</div>
</template>


<script>
import Vue from 'vue'
import { validationMixin } from "vuelidate";
import { required, minLength,numeric, minValue, maxLength, email,alpha,helpers } from "vuelidate/lib/validators";

import TreatmentList from './VaccinationList'
import VaccinationPrintCard from './VaccinationPrintCard'
const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
const formShape = {
  searchText: null,
  firstName: null,
  lastName: null,
  address: null,
  mobile: null,
  doses:{},
  id: null,
  adharCardNumber:null
}
export default {
name: 'VimsEntryForm',
components: {
  TreatmentList,
  VaccinationPrintCard

},

data: function() {
  return {
    form: Object.assign({}, formShape),
    selectedSearchOption : false,
    patients: [],
    numberOfTreatments: 0,
    showPrintCard: false,
    person:[],
    doses:[]

  }
},
validations: {
  form: {
    firstName: {
      required,
      alpha_space
    },
    lastName: {
      alpha_space
    },
    address: {
      required
    },
    mobile: {
      required,
      numeric,
      minLength : minLength(10),
      maxLength : maxLength(12)
    },
    doses: {
      required,
      $each: {
        vtype: {
          required,
        },
        dose: {
          required
        },
        date: {
          required
        }
      }
    }

  }
},
computed: {
  showListGroup : function(){
    var strMob = '' + this.form.searchText;
    return (this.patients.length > 0 && this.selectedSearchOption === false && strMob.length >= 7)
  },
},
watch: {

  'form.searchText': function(value){
    let params = {"cardNo": value};
    if(value != null && value.length >= 5 && this.selectedSearchOption == false){
      this.$store.dispatch('vims/getPatientByIdCard', params)
        .then((response) => {
              this.patients = response.data.data;
        })
        .catch((error) => {
        });
    }

  }
},
methods: {
   async setVacCardData(data){
     let person = [];
     let doses = [];
     person['srNo'] = data.srNo;
     person['name'] = data.name;
     person['mobile'] = data.mobile;
     person['cardNo'] = data.cardNo;
     person['address'] = data.address;
     doses = data.doses;
     this.$refs.vacPrintCard.setCardData(person,doses);
     await this.sleep(1000);
     this.$htmlToPaper('vCard');
     this.onReset();

   },

   sleep(ms) {
     return new Promise((resolve) => {
       setTimeout(resolve, ms);
    });
  },
   printVaccinationCard (data) {
     // Pass the element id here


   },
   addTreatment() {
    if (this.numberOfTreatments < 2) {
      this.numberOfTreatments++;
      this.$refs.treatmentList.addTreatment()
    }
  },
  removeTreatment() {
    if (this.numberOfTreatments > 0) {
        this.numberOfTreatments--
      this.$refs.treatmentList.removeTreatment()
    }
  },
  createPatientModal(){

  },
  setDoses(param){
    this.form.doses = param;
  },
  validateState(name) {
    const { $dirty, $error } = this.$v.form[name];
    return $dirty ? !$error : null;
  },
  showListGroup : function(){
    var strSearchText = '' + this.form.searchText;
    return (this.patients.length > 0 && this.selectedSearchOption === false && strSearchText.length >= 5)
  },
  searchBlur(){
    if(this.showListGroup == true && event.relatedTarget.parentNode != null && event.relatedTarget.parentNode.id !='searchTextList' ){
     this.selectedSearchOption = true;
    }
  },
  searchTextFocused(){
      this.selectedSearchOption = false;
  },
  keydownMethod(index){
    if(index == (this.patients.length - 1) && event.keyCode == 9 && event.shiftKey == false){
      event.preventDefault();
      this.$refs.listIndexes[index].focus();
      return false;

    }
    else if (index == 0 && event.keyCode == 9 && event.shiftKey == true ){
      this.patients = [];
    }
  },
  keyupMethod(index){
    if(event.keyCode == 27){
      this.selectedSearchOption = true;
    }
  },
  searchListClicked(item){
    this.selectedSearchOption = true;
    this.form.firstName = item.name;
    this.form.lastName = item.lastName;
    this.form.address = item.city;
    this.form.mobile = item.phone;
    this.form.id = item.cardNo;
    this.patients = [];

  },
  isValid() {
    this.$v.$touch();
    return !this.$v.form.$anyError
  },
  onSubmit(evt){

    console.log(JSON.stringify(this.form, null, 4));
    if(this.isValid){
      this.submitted = true;
      this.$refs.submitButton.disabled = true;
      this.$nextTick(() => {
        let params = JSON.stringify(this.form);
        this.$store.dispatch('vims/createVimsEntry', params)
          .then((response) => {
            if(response.data.success == false){
                this.showErrorMsg({
                  message: response.data.error
                });
                this.$refs.submitButton.disabled = false;
            }
            else{
                    this.showSuccessMsg({
                      message: 'Record Added successfully.'
                    });
                    this.showPrintCard = false;
                    this.setVacCardData(response.data.data);

            }
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.showErrorMsg({
                message: error.response.data.message
              })
            }
            else if (error.response.status == 422){
                this.showErrorMsg({
                  message: error.response.data.message
                });
                this.showDismissibleAlert=true;
                var errors = Object.values(error.response.data.errors);
                this.submissionErros = errors;

            }
            else {
              this.showErrorMsg()
            }
            this.$refs.submitButton.disabled = false;
          })


      });
    }
  },

  onReset() {
    // Reset validation
    this.form = Object.assign({}, formShape);
    this.numberOfTreatments = 0;
    this.$refs.treatmentList.onReset();
    this.$refs.vacPrintCard.resetData();
    this.submitted = false;
    this.$nextTick(() => {
      this.$v.$reset()
    })
    this.$emit('success')
  },
},
mounted(){
    this.form = Object.assign({}, formShape);
},
created () {
  if (this.$store.state.vims.vaccineTypes.length == 0) {
    this.$store.dispatch('vims/getVaccineTypes');
  }
  this.form = Object.assign({}, formShape);
  this.numberOfTreatments = 0;

},
destroyed () {
},


}

</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
